<h2 mat-dialog-title>{{ isEdicao ? 'Editar Conjunto de Conta Contábil' : 'Cadastrar Conjunto de Conta Contábil' }}</h2>

<mat-dialog-content>
    <form (ngSubmit)="salvar()" [formGroup]="form" style="min-width: 500px; padding: 20px 0;">
        <div fxLayout="column" fxLayoutGap="20px">

            <!-- Campo Categoria Origem -->
            <div fxFlexFill fxLayout="row" fxLayoutAlign="start center">
                <div [ngStyle]="{width: '100%'}">
                    <app-combo-generico
                            (mudancaSelecao)="onCategoriaOrigemChange($event)"
                            [placeholder]="'Conta Contábil Origem *'"
                            [configuracao]="configuracaoSeletorCategoria"
                            [opcoes]="comboPlanosContas"
                            [desabilitado]="buscandoArgumento || categoriasDesabilitadas || categoriaOrigemDesabilitada"
                            [valor]="form.get('idCategoriaOrigem')?.value">
                    </app-combo-generico>
                </div>
            </div>

            <!-- Campo Categoria Destino -->
            <div fxFlexFill fxLayout="row" fxLayoutAlign="start center">
                <div [ngStyle]="{width: '100%'}">
                    <app-combo-generico
                            (mudancaSelecao)="onCategoriaDestinoChange($event)"
                            [placeholder]="'Conta Contábil Destino *'"
                            [configuracao]="configuracaoSeletorCategoria"
                            [opcoes]="comboPlanosContas"
                            [desabilitado]="buscandoArgumento || categoriasDesabilitadas || categoriaDestinoDesabilitada"
                            [valor]="form.get('idCategoriaDestino')?.value">
                    </app-combo-generico>
                </div>
            </div>

            <!-- Campo Tipo Importação -->
            <div fxFlexFill fxLayout="row" fxLayoutAlign="start center">
                <div [ngStyle]="{width: '100%'}">
                    <app-combo-generico
                            (mudancaSelecao)="onTipoLancamentoChange($event)"
                            [placeholder]="'Tipo Importação'"
                            [configuracao]="configuracaoSeletorTipoLancamento"
                            [opcoes]="comboTiposLancamento"
                            [desabilitado]="buscandoArgumento"
                            [valor]="form.get('idTipoLancamento')?.value">
                    </app-combo-generico>
                </div>
            </div>

            <!-- Indicador de busca -->
            <div *ngIf="buscandoArgumento" fxFlexFill fxLayout="row" fxLayoutAlign="start center" style="padding: 10px 0;">
                <mat-icon style="color: #2196F3; margin-right: 8px;">search</mat-icon>
                <span style="color: #666; font-size: 14px;">Buscando argumento existente...</span>
            </div>

            <!-- Mensagem de argumento encontrado em modo edição -->
            <div *ngIf="isEdicao && categoriasDesabilitadas && !buscandoArgumento" fxFlexFill fxLayout="row"
                 fxLayoutAlign="start center"
                 style="padding: 10px; background-color: #E3F2FD; border-radius: 4px; margin-bottom: 10px;">
                <mat-icon style="color: #2196F3; margin-right: 8px;">info</mat-icon>
                <span style="color: #1976D2; font-size: 14px;">Você está editando um argumento existente. As categorias contábeis não podem ser alteradas.</span>
            </div>

            <!-- Campo Argumentos -->
            <div fxFlexFill fxLayout="column" fxLayoutGap="10px">
                <div style="margin-bottom: 10px;">
                    <label style="font-weight: 500; color: rgba(0,0,0,.87);">Argumentos (Palavras-chave)</label>
                </div>

                <div fxLayout="column" fxLayoutGap="10px">
                    <div *ngFor="let argumentoControl of getArgumentosFormArray().controls; let i = index"
                         fxLayout="row"
                         fxLayoutAlign="start center"
                         fxLayoutGap="10px"
                         fxFlexFill>
                        <mat-form-field fxFlex="1 1 auto" style="width: 100%;">
                            <input #inputArgumento
                                   [formControl]="argumentoControl"
                                   matInput
                                   maxlength="255"
                                   placeholder="Digite parte da descrição da transação">
                            <mat-hint align="end">{{ argumentoControl.value?.length || 0 }}/255</mat-hint>
                            <mat-error *ngIf="argumentoControl.hasError('minlength')">
                                Este campo deve ter no mínimo 5 caracteres
                            </mat-error>
                            <mat-error *ngIf="argumentoControl.hasError('maxlength')">
                                Este campo excede o limite de 255 caracteres
                            </mat-error>
                            <mat-error *ngIf="argumentoControl.hasError('apenasWildcards')">
                                O argumento não pode conter apenas wildcards {{ '{' }}*{{ '}' }}. É necessário ter pelo menos 5 caracteres de texto além dos wildcards.
                            </mat-error>
                        </mat-form-field>
                        <button (click)="inserirWildcard(i, inputArgumento)"
                                color="accent"
                                mat-icon-button
                                [matTooltip]="'Inserir wildcard {' + '*' + '} (coringa para busca)'"
                                type="button"
                                style="flex-shrink: 0;">
                            <mat-icon>flag</mat-icon>
                        </button>
                        <button (click)="removerLinhaArgumento(i)"
                                *ngIf="getArgumentosFormArray().length > 1"
                                mat-icon-button
                                matTooltip="Remover argumento"
                                type="button"
                                style="flex-shrink: 0; color: black;">
                            <mat-icon style="color: black;">delete</mat-icon>
                        </button>
                    </div>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" style="margin-top: 10px;">
                    <button (click)="adicionarLinhaArgumento()"
                            color="primary"
                            mat-mini-fab
                            matTooltip="Adicionar nova linha"
                            type="button"
                            style="width: 160px; border-radius: 5px;">
                        <mat-icon>add</mat-icon>
                        Argumento
                    </button>
                </div>

                <div *ngIf="form.get('argumentos')?.hasError('peloMenosUmArgumento')" style="color: #f44336; font-size: 12px; margin-top: 5px;">
                    <mat-icon style="font-size: 14px; vertical-align: middle;">error</mat-icon>
                    É necessário adicionar pelo menos um argumento com no mínimo 5 caracteres (sem contar apenas wildcards).
                </div>
                <div style="color: #999; font-size: 12px; margin-top: 5px;">
                    Adicione múltiplos argumentos/palavras-chave para melhorar a conciliação automática.
                    Use o botão
                    <mat-icon style="font-size: 14px; vertical-align: middle;">flag</mat-icon>
                    para inserir o wildcard <strong>{{ '{' }}*{{ '}' }}</strong> que será usado como coringa nas buscas do banco
                    de dados.
                    É obrigatório ter pelo menos um argumento válido (mínimo 5 caracteres de texto, além dos wildcards).
                </div>
            </div>

            <!-- Campo Ativo -->
            <div fxFlexFill fxLayout="row" fxLayoutAlign="start center">
                <mat-slide-toggle color="primary" formControlName="ativo">
                    Ativo
                </mat-slide-toggle>
            </div>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
    <button (click)="cancelar()"
            [disabled]="isLoading"
            mat-button
            type="button">
        CANCELAR
    </button>
    <button (click)="salvar()"
            [disabled]="form.invalid || isLoading || buscandoArgumento"
            color="primary"
            mat-raised-button
            type="button">
        <mat-icon *ngIf="isLoading" class="spinner">hourglass_empty</mat-icon>
        {{ isEdicao ? 'ALTERAR' : 'SALVAR' }}
    </button>
</mat-dialog-actions>

